import { apyRatesAtomDefinition } from './atoms/index.js'
import apyRatesMonitorDefinition, { DEFAULT_FETCH_INTERVAL } from './monitor/index.js'
import apyRatesPlugin from './plugin/index.js'

const apyRates = (config = Object.create(null)) => {
  return {
    id: 'apyRates',
    definitions: [
      {
        definition: apyRatesMonitorDefinition,
        config: {
          stakingAssetNames: config.stakingAssetNames,
          fetchInterval: config.fetchInterval || DEFAULT_FETCH_INTERVAL,
        },
      },
      { definition: apyRatesAtomDefinition },
      { definition: apyRatesPlugin },
    ],
  }
}

export default apyRates
